function ForgotPassword() {
  return <>Forgot Password page</>;
}
export default ForgotPassword;
